import {CustomIcon} from '@guestapp/old-ui-kit';
import {
  BackgroundImage,
  BackgroundImageOverlay,
  ContentImage,
  ContentPicture,
  HomeSectionLink,
  ContentWrapper,
  Tags,
  AdditionalText,
  Title,
  Tag,
  TitleTag,
} from './styled';
import {HomeSectionHeader} from 'components/HomeSection';
import {DEVICE, useScreenResize} from '@chekin/guestapp-ui-kit';
import mozioBg from './mozio-bg.webp';
import mozioImage from './mozio-image.png';
import mozioImageMobile from './mozio-image-mobile.png';
import {useTranslation} from 'react-i18next';
import {useTheme} from 'styled-components';
import {usePostHogTrack, POSTHOG_EVENTS} from 'analytics';
import {getUserIdFromToken} from '@chekin/api';

const MOZIO_ORIGIN = 'https://chekin.mozio.com';

const Picture = () => (
  <ContentPicture>
    <source srcSet={mozioImageMobile} media={`(max-width: ${DEVICE.laptop})`} />
    <source srcSet={mozioImage} media={`(min-width: ${DEVICE.laptop})`} />
    <ContentImage src={mozioImage} alt="" />
  </ContentPicture>
);

const createMozioHref = () => {
  try {
    return `${MOZIO_ORIGIN}/?partner_tracking_id=${getUserIdFromToken()}`;
  } catch (error) {
    console.error(error);
    return MOZIO_ORIGIN;
  }
};

type Props = {
  className?: string;
  housingId: string;
};
const Mozio = ({className, housingId}: Props) => {
  const {isMatch: isMobileMode} = useScreenResize(DEVICE.laptop);
  const {t} = useTranslation();
  const theme = useTheme();
  const {trackEvent} = usePostHogTrack();

  return (
    <HomeSectionLink
      className={className}
      href={createMozioHref()}
      noArrow={isMobileMode}
      target="_blank"
      onClick={() =>
        trackEvent(POSTHOG_EVENTS.PARTNER_CLICKED, {
          partner: 'mozio',
          partner_category: 'transportation',
          housing_id: housingId,
          destination: MOZIO_ORIGIN,
        })
      }
    >
      <CustomIcon
        name="carCircle"
        size={40}
        aria-hidden="true"
        color={theme.hasTemplate ? theme.colors.branding.icons : '#777E91'}
      />
      <ContentWrapper>
        {!isMobileMode && <Picture />}
        <HomeSectionHeader
          title={
            <Title>
              {t('airport_city_transfers')}{' '}
              {!isMobileMode && <TitleTag>{t('hot_deal')}</TitleTag>}
            </Title>
          }
          subtitle={
            isMobileMode
              ? t('pre_book_your_ride_with_trusted_local_partners_mobile')
              : t('pre_book_your_ride_with_trusted_local_partners')
          }
        />
        <AdditionalText>{t('discover_unbeatable_rates')}</AdditionalText>
        <Tags>
          <Tag>{t('free_cancellation')}</Tag>
          <Tag>{t('support_24_7')}</Tag>
          <Tag>{t('instant_confirmation')}</Tag>
          {isMobileMode && <Picture />}
        </Tags>
      </ContentWrapper>

      <BackgroundImage src={mozioBg} />
      <BackgroundImageOverlay />
    </HomeSectionLink>
  );
};

export {Mozio};
